export default function searchButton() {
    const open = document.querySelector(".open");
    const block = document.getElementById("menu__block");

    if (open && block) {
        open.addEventListener("click", () => {
            if (block.classList.contains("is-active")) {
                open.classList.remove("is-active");
                block.classList.remove("is-active");
                setTimeout(() => {
                    block.style.display = "none";
                }, 400);
            } else {
                open.classList.add("is-active");
                block.style.display = "flex";
                setTimeout(() => {
                    block.classList.add("is-active");
                }, 10);
            }
        });
    }
}